import PrinterWebUsb from './PrinterWebUsb'
import PrinterWebWifi from './PrinterWebWifi'

// export default (mode) => (mode === 'USB' ? new PrinterWebUsb() : new PrinterWebWifi())
export default (mode) => new PrinterWebUsb()
